(function(config) {
    'use strict';

    angular.module('allegro.services', [
            'ngResource'
        ])
        .factory('allegroAccountDataSrvc', allegroAccountDataSrvc)
        .factory('allegroConfigDataSrvc', allegroConfigDataSrvc)
        .factory('allegroSellersDataSrvc', allegroSellersDataSrvc)
        .factory('allegroSendersDataSrvc', allegroSendersDataSrvc)
        .factory('allegroCodReceiversDataSrvc', allegroCodReceiversDataSrvc)
        .factory('allegroResponsibleProducersDataSrvc', allegroResponsibleProducersDataSrvc)
        .factory('allegroSafetyInformationsDataSrvc', allegroSafetyInformationsDataSrvc)
        .factory('allegroSrvc', allegroSrvc)
        .factory('allegroOffersDataSrvc', allegroOffersDataSrvc)
        .factory('allegroThreadsDataSrvc', allegroThreadsDataSrvc);

    allegroAccountDataSrvc.$inject = ['$resource'];

    function allegroAccountDataSrvc($resource) {
        return $resource(config.api + '/api/v1/allegro/accounts/:pk/', {pk: '@pk'}, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
                url: config.api + '/api/v1/allegro/accounts/',
            },
            update: {
                method: 'PUT'
            },
            delete: {
                method: 'DELETE'
            },
            getOAuthData: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/:pk/oauth_data/',
                isArray: false
            },
            getSellerData: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/:pk/seller_data/',
                isArray: false
            },
            getSenderData: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/:pk/sender_data/',
                isArray: false
            },
            getCodReceiverData: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/:pk/cod_receiver_data/',
                isArray: false
            },
            getResponsibleProducerData: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/:pk/responsible_producer/',
                isArray: false
            },
            getSafetyInformationData: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/:pk/product_safety_information/',
                isArray: false
            },
            getOffers: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/:pk/offers/',
                isArray: false
            },
            getThreads: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/:pk/threads/',
                isArray: false
            },
            getCategories: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/:pk/categories/',
                isArray: false
            },
            getMatchingCategories: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/:pk/matching_categories/',
                isArray: false
            },
            getCategoryParameters: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/:pk/category_parameters/',
                isArray: false
            },
            getShoppingRates: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/:pk/shoping_rates/',
                isArray: false
            },
            getImpliedWarranties: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/:pk/implied_warranties/',
                isArray: false
            },
            getReturnPolicies: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/:pk/return_policies/',
                isArray: false
            },
            getPublicationDurations: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/:pk/publication_durations/',
                isArray: true
            },
            getDeliveryHandlingTimes: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/:pk/delivery_handling_times/',
                isArray: true
            },
            getFieldOpts: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/accounts/form_field_opts/'
            }
        });
    }

    allegroConfigDataSrvc.$inject = ['$resource'];

    function allegroConfigDataSrvc($resource) {
        return $resource(config.api + '/api/v1/allegro/configurations/:pk/', {pk: '@pk'}, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/configurations/',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            delete: {
                method: 'DELETE'
            },
            getDeviceFlow: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/configurations/:pk/device_flow/',
                isArray: false
            },
            getAuthInfo:{
                method: 'GET',
                url: config.api + '/api/v1/allegro/configurations/:pk/auth_info/',
                isArray: false
            },
            revokeToken:{
                method: 'GET',
                url: config.api + '/api/v1/allegro/configurations/:pk/revoke_token/',
                isArray: false
            },
        });
    }

    allegroSellersDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function allegroSellersDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/allegro/sellers/:pk/', {pk: '@pk'}, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/sellers/',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PUT',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    allegroSendersDataSrvc.$inject = ['$resource'];

    function allegroSendersDataSrvc($resource) {
        return $resource(config.api + '/api/v1/allegro/senders/:pk/', {pk: '@pk'}, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/senders/',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            delete: {
                method: 'DELETE'
            }
        });
    }


    allegroCodReceiversDataSrvc.$inject = ['$resource'];

    function allegroCodReceiversDataSrvc($resource) {
        return $resource(config.api + '/api/v1/allegro/cod-receivers/:pk/', {pk: '@pk'}, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/cod-receivers/',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            delete: {
                method: 'DELETE'
            }
        });
    }


    allegroResponsibleProducersDataSrvc.$inject = ['$resource'];

    function allegroResponsibleProducersDataSrvc($resource) {
        return $resource(config.api + '/api/v1/allegro/responsible-producers/:pk/', {pk: '@pk'}, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/responsible-producers/',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            delete: {
                method: 'DELETE'
            }
        });
    }


    allegroSafetyInformationsDataSrvc.$inject = ['$resource'];

    function allegroSafetyInformationsDataSrvc($resource) {
        return $resource(config.api + '/api/v1/allegro/safety-informations/:pk/', {pk: '@pk'}, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                url: config.api + '/api/v1/allegro/safety-informations/',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    allegroSrvc.$inject = ['$uibModal', 'modalSrvc', 'allegroConfigDataSrvc', 'allegroOffersDataSrvc'];
    function allegroSrvc($uibModal, modalSrvc, allegroConfigDataSrvc, allegroOffersDataSrvc) {
        return {
            categorySelectModal: categorySelectModal,
            remove: remove,
            removeOffer: removeOffer,
            deliveryTimeHandlingChangeModal: deliveryTimeHandlingChangeModal,
            priceChangeModal: priceChangeModal,
            revokeAccountToken: revokeAccountToken
        };

        function categorySelectModal(dataObj, okCallback, cancelCallback) {
            $uibModal.open({
                templateUrl: 'app/allegro/views/category-select-modal/category-select-modal.html',
                controller: 'AllegroCategorySelectModalController',
                controllerAs: 'ctrl',
                size: 'lg',
                windowClass: 'category-select-modal',
                resolve: {
                    dataObj: function () {
                        return dataObj;
                    }
                }
            }).result.then(okCallback, cancelCallback);
        }

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    allegroConfigDataSrvc.delete({pk: pk}).$promise.then(successCallback, errorCallback);
                }
            );
        }

        function revokeAccountToken(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmAction(
                title,
                function() {
                    allegroConfigDataSrvc.revokeToken({pk: pk}).$promise.then(successCallback, errorCallback);
                }
            );
        }

        function deliveryTimeHandlingChangeModal(dataObj, okCallback, cancelCallback) {
            $uibModal.open({
                templateUrl: 'app/allegro/views/offer-create-modification-cmd-modal/offer-create-modification-cmd-modal.html',
                controller: 'AllegroCreateModificationCmdModalController',
                controllerAs: 'ctrl',
                size: 'md',
                windowClass: 'allegro-modal',
                resolve: {
                    dataObj: function () {
                        return dataObj;
                    }
                }
            }).result.then(okCallback, cancelCallback);
        }

        function priceChangeModal(dataObj, okCallback, cancelCallback) {
            $uibModal.open({
                templateUrl: 'app/allegro/views/offer-create-price-change-cmd-modal/offer-create-price-change-cmd-modal.html',
                controller: 'AllegroCreatePriceChangeCmdModalController',
                controllerAs: 'ctrl',
                size: 'md',
                windowClass: 'allegro-modal',
                resolve: {
                    dataObj: function () {
                        return dataObj;
                    }
                }
            }).result.then(okCallback, cancelCallback);
        }

        function removeOffer(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    allegroOffersDataSrvc.delete({pk: pk}).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    allegroOffersDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];
    function allegroOffersDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/allegro/offers/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
            },
            update: {
                method: 'PATCH',
            },
            delete: {
                method: 'DELETE',
            },
            createModificationCmd: {
                method: 'POST',
                url: config.api + '/api/v1/allegro/offers/create_modification_command/',
            },
            createPriceChangeCmd: {
                method: 'POST',
                url: config.api + '/api/v1/allegro/offers/create_price_change_command/',
            }
        });
    }

    allegroThreadsDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];
    function allegroThreadsDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/allegro/threads/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            createMessage: {
                method: 'POST',
                url: config.api + '/api/v1/allegro/threads/:pk/create_message/',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.multipleFormDataTransform
            },
        });
    }
})(window.config);
